import { useContext } from 'react';
import { DrawerContext } from '../Contexts/DrawerContext';

export const useDrawer = () => useContext(DrawerContext);
